import { AROrgeCampaign, AROrgeOrder, AROrgeOrderItem } from '../../../../models/agrorendement-orge.model';
import { KeycloakService } from '../../../../services/keycloak.service';
import { correctDate } from '../../../../utils/utils';

export class AROrgeUtils {
  public static isOrderEditable(order: AROrgeOrder): boolean {
    const isAdmin = KeycloakService.auth.authz.hasRealmRole('ROLE_ADMIN');
    const today = correctDate(new Date());
    const campaign = order.campaign;
    const config = campaign.configuration;

    // si non admin => false
    if (!isAdmin) {
      return false;
    }

    // Une offre à trois passages commence par le T1 : elle reste modifiable
    // tant que les commandes T1 sont ouvertes. Sans date de fin, elle reste ouverte.
    if (order.orderItems && order.orderItems.some((orderItem) => orderItem.hasT1)) {
      return (
        config.orderT1EndingOn === null ||
        config.orderT1EndingOn === undefined ||
        today <= config.orderT1EndingOn
      );
    }

    // Une offre à deux passages commence par le T2 : elle dépend donc de la date T2.
    if (order.orderItems && order.orderItems.some((orderItem) => orderItem.hasT2)) {
      return (
        config.orderT2EndingOn === null ||
        config.orderT2EndingOn === undefined ||
        today <= config.orderT2EndingOn
      );
    }

    // L'offre restante correspond au T3 seul et dépend de la date de commande T3.
    return (
      config.orderT3EndingOn === null ||
      config.orderT3EndingOn === undefined ||
      today <= config.orderT3EndingOn
    );
  }

  public static isCampaignCurrentlyOpen(campaign: AROrgeCampaign): boolean {
    const today = correctDate(new Date());
    const config = campaign.configuration;
    // La campagne reste ouverte jusqu'à la fin de saisie du dernier passage.
    return (
      config.startingOn <= today &&
      (config.dataT3EndingOn === null || config.dataT3EndingOn === undefined || config.dataT3EndingOn >= today)
    );
  }

  public static isT1DataCurrentlyOpen(campaign: AROrgeCampaign): boolean {
    const today = correctDate(new Date());
    const config = campaign.configuration;
    return (
      config.startingOn <= today &&
      (config.dataT1EndingOn === null || config.dataT1EndingOn === undefined || config.dataT1EndingOn >= today)
    );
  }

  public static isT1OrderCurrentlyOpen(campaign: AROrgeCampaign): boolean {
    const today = correctDate(new Date());
    const config = campaign.configuration;
    return (
      config.startingOn <= today &&
      (config.orderT1EndingOn === null || config.orderT1EndingOn === undefined || config.orderT1EndingOn >= today)
    );
  }

  public static isT2DataCurrentlyOpen(campaign: AROrgeCampaign): boolean {
    const today = correctDate(new Date());
    const config = campaign.configuration;
    return (
      config.startingOn <= today &&
      (config.dataT2EndingOn === null || config.dataT2EndingOn === undefined || config.dataT2EndingOn >= today)
    );
  }

  public static isT2OrderCurrentlyOpen(campaign: AROrgeCampaign): boolean {
    const today = correctDate(new Date());
    const config = campaign.configuration;
    return (
      config.startingOn <= today &&
      (config.orderT2EndingOn === null || config.orderT2EndingOn === undefined || config.orderT2EndingOn >= today)
    );
  }

  public static isT3DataCurrentlyOpen(campaign: AROrgeCampaign): boolean {
    const today = correctDate(new Date());
    const config = campaign.configuration;
    return (
      config.startingOn <= today &&
      (config.dataT3EndingOn === null || config.dataT3EndingOn === undefined || config.dataT3EndingOn >= today)
    );
  }

  public static isT3OrderCurrentlyOpen(campaign: AROrgeCampaign): boolean {
    const today = correctDate(new Date());
    const config = campaign.configuration;
    return (
      config.startingOn <= today &&
      (config.orderT3EndingOn === null || config.orderT3EndingOn === undefined || config.orderT3EndingOn >= today)
    );
  }

  public static canBeOrdered(
    orderItem: AROrgeOrderItem,
    hasOpenedCampaign: boolean,
    isT1OrderCurrentlyOpen: boolean,
    isT2OrderCurrentlyOpen: boolean,
    isT3OrderCurrentlyOpen: boolean,
  ): boolean {
    // TODO implémenter ces conditions sur le serveur
    // La date du premier passage de l'offre détermine si l'élément peut être commandé.
    return (
      orderItem &&
      !orderItem.order &&
      hasOpenedCampaign &&
      (orderItem.hasT1
        ? isT1OrderCurrentlyOpen
        : orderItem.hasT2
          ? isT2OrderCurrentlyOpen
          : orderItem.hasT3 && isT3OrderCurrentlyOpen)
    );
  }
}
